export const isVersionGreater = (a, b) => {
  if (b === undefined) return true;
  const pa = a.split('.').map(Number);
  const pb = b.split('.').map(Number);

  const len = Math.max(pa.length, pb.length);

  for (let i = 0; i < len; i++) {
    const na = pa[i] ?? 0;
    const nb = pb[i] ?? 0;

    if (na > nb) return true;
    if (na < nb) return false;
  }

  return false; // equal
};
